export const fsConsts = {
   charRegExp: '\\u0041-\\u005A\\u0061-\\u007A\\u00A7\\u00AA\\u00B5\\u00B6\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0\\u08A2-\\u08AC\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097F\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191C\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2010-\\u203B\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2183\\u2184\\u2225\\u2460-\\u266F\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3015\\u3031-\\u3035\\u303B\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA697\\uA6A0-\\uA6E5\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7F8-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA80-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF03-\\uFF0F\\uFF20-\\uFF3F\\uFF41-\\uFF60\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC\\uFFE3',
   // Refer to https://msdn.microsoft.com/en-us/library/ms724228
   timeBase: 11644473600000,
   timeMultiply: 10000,
   volumeInfo: {
      blocks: 32 * 1024 * 1024,
      bfree: 16 * 1024 * 1024,
      bavail: 16 * 1024 * 1024,
      bsize: 1024,
      namemax: 200
   },
   folderSize: 0,
   remoteSeparator: '\\',
   localSeparator: '/'
};

export const FILE_TYPES = {
   S_IFMT: 0xf000,
   S_TYPES: {
      S_IFSOCK: 0xc000,
      S_IFLNK: 0xa000, //symbolic link
      S_IFREG: 0x8000, //regular
      S_IFBLK: 0x6000, //character special (device)
      S_IFDIR: 0x4000, //directory
      S_IFCHR: 0x2000, //character special (device)
      S_IFIFO: 0x1000, //FIFO special(pipe)
      S_ISUID: 0x0800, //set-user-ID on execution
      S_ISGID: 0x0400, //set-group-ID on execution
      S_ISVTX: 0x0200 //on directories, restricted deletion flag
   },
   OPERATION_REQUEST: {
      FILE_SUPERSEDE: 0x00000000,
      FILE_OPEN: 0x00000001,
      FILE_CREATE: 0x00000002,
      FILE_OPEN_IF: 0x00000003,
      FILE_OVERWRITE: 0x00000004,
      FILE_OVERWRITE_IF: 0x00000005,
      FILE_MAXIMUM_DISPOSITION: 0x00000005 //not typo
   },
   OPERATION_RESPONSE: {
      FILE_SUPERSEDED: 0x00000000,
      FILE_OPENED: 0x00000001,
      FILE_CREATED: 0x00000002,
      FILE_OVERWRITTEN: 0x00000003,
      FILE_EXISTS: 0x00000004,
      FILE_DOES_NOT_EXIST: 0x00000005
   },
   FILE_INFORMATION_CLASS: {
      FileDirectoryInformation: 1,
      FileFullDirectoryInformation: 2,
      FileBothDirectoryInformation: 3,
      FileBasicInformation: 4,
      FileStandardInformation: 5,
      FileInternalInformation: 6,
      FileEaInformation: 7,
      FileAccessInformation: 8,
      FileNameInformation: 9,
      FileRenameInformation: 10,
      FileLinkInformation: 11,
      FileNamesInformation: 12,
      FileDispositionInformation: 13,
      FilePositionInformation: 14,
      FileFullEaInformation: 15,
      FileModeInformation: 16,
      FileAlignmentInformation: 17,
      FileAllInformation: 18,
      FileAllocationInformation: 19,
      FileEndOfFileInformation: 20,
      FileAlternateNameInformation: 21,
      FileStreamInformation: 22,
      FilePipeInformation: 23,
      FilePipeLocalInformation: 24,
      FilePipeRemoteInformation: 25,
      FileMailslotQueryInformation: 26,
      FileMailslotSetInformation: 27,
      FileCompressionInformation: 28,
      FileObjectIdInformation: 29,
      FileCompletionInformation: 30,
      FileMoveClusterInformation: 31,
      FileQuotaInformation: 32,
      FileReparsePointInformation: 33,
      FileNetworkOpenInformation: 34,
      FileAttributeTagInformation: 35,
      FileTrackingInformation: 36,
      FileIdBothDirectoryInformation: 37,
      FileIdFullDirectoryInformation: 38,
      FileValidDataLengthInformation: 39,
      FileShortNameInformation: 40,
      FileIoCompletionNotificationInformation: 41,
      FileIoStatusBlockRangeInformation: 42,
      FileIoPriorityHintInformation: 43,
      FileSfioReserveInformation: 44,
      FileSfioVolumeInformation: 45,
      FileHardLinkInformation: 46,
      FileProcessIdsUsingFileInformation: 47,
      FileNormalizedNameInformation: 48,
      FileNetworkPhysicalNameInformation: 49,
      FileIdGlobalTxDirectoryInformation: 50,
      FileIsRemoteDeviceInformation: 51,
      FileAttributeCacheInformation: 52,
      FileNumaNodeInformation: 53,
      FileStandardLinkInformation: 54,
      FileRemoteProtocolInformation: 55,
      FileMaximumInformation: 56
   },
   ATTRIBUTE_BITS: {
      FILE_ATTRIBUTE_READONLY: 0x00000001,
      FILE_ATTRIBUTE_HIDDEN: 0x00000002,
      FILE_ATTRIBUTE_SYSTEM: 0x00000004,
      FILE_ATTRIBUTE_DIRECTORY: 0x00000010,
      FILE_ATTRIBUTE_ARCHIVE: 0x00000020,
      FILE_ATTRIBUTE_DEVICE: 0x00000040,
      FILE_ATTRIBUTE_NORMAL: 0x00000080,
      FILE_ATTRIBUTE_TEMPORARY: 0x00000100,
      FILE_ATTRIBUTE_SPARSE_FILE: 0x00000200,
      FILE_ATTRIBUTE_REPARSE_POINT: 0x00000400,
      FILE_ATTRIBUTE_COMPRESSED: 0x00000800,
      FILE_ATTRIBUTE_OFFLINE: 0x00001000,
      FILE_ATTRIBUTE_NOT_CONTENT_INDEXED: 0x00002000,
      FILE_ATTRIBUTE_ENCRYPTED: 0x00004000,
      FILE_ATTRIBUTE_VIRTUAL: 0x00010000
   },
   FILE_ATTRIBUTES: {
      FILE_CASE_SENSITIVE_SEARCH: 0x00000001,
      FILE_CASE_PRESERVED_NAMES: 0x00000002,
      FILE_UNICODE_ON_DISK: 0x00000004
   },
   WINTERNL: {
      FILE_DIRECTORY_FILE: 0x00000001,
      FILE_WRITE_THROUGH: 0x00000002,
      FILE_SEQUENTIAL_ONLY: 0x00000004,
      FILE_NO_INTERMEDIATE_BUFFERING: 0x00000008,
      FILE_SYNCHRONOUS_IO_ALERT: 0x00000010,
      FILE_SYNCHRONOUS_IO_NONALERT: 0x00000020,
      FILE_NON_DIRECTORY_FILE: 0x00000040,
      FILE_CREATE_TREE_CONNECTION: 0x00000080,
      FILE_COMPLETE_IF_OPLOCKED: 0x00000100,
      FILE_NO_EA_KNOWLEDGE: 0x00000200,
      FILE_OPEN_REMOTE_INSTANCE: 0x00000400,
      FILE_RANDOM_ACCESS: 0x00000800,
      FILE_DELETE_ON_CLOSE: 0x00001000,
      FILE_OPEN_BY_FILE_ID: 0x00002000,
      FILE_OPEN_FOR_BACKUP_INTENT: 0x00004000,
      FILE_NO_COMPRESSION: 0x00008000,
      FILE_OPEN_REQUIRING_OPLOCK: 0x00010000,
      FILE_RESERVE_OPFILTER: 0x00100000,
      FILE_OPEN_REPARSE_POINT: 0x00200000,
      FILE_OPEN_NO_RECALL: 0x00400000,
      FILE_OPEN_FOR_FREE_SPACE_QUERY: 0x00800000
   },
   // not exactly, but good enough for logging
   ACCESS: {
      GENERIC_READ: 0x80,
      GENERIC_WRITE: 0x40,
      GENERIC_EXECUTE: 0x20,
      GENERIC_ALL: 0x10
   }
};

export const DEVICE_TYPES = {
   FILE_DEVICE_BEEP: 0x00000001,
   FILE_DEVICE_CD_ROM: 0x00000002,
   FILE_DEVICE_CD_ROM_FILE_SYSTEM: 0x00000003,
   FILE_DEVICE_CONTROLLER: 0x00000004,
   FILE_DEVICE_DATALINK: 0x00000005,
   FILE_DEVICE_DFS: 0x00000006,
   FILE_DEVICE_DISK: 0x00000007,
   FILE_DEVICE_DISK_FILE_SYSTEM: 0x00000008,
   FILE_DEVICE_FILE_SYSTEM: 0x00000009,
   FILE_DEVICE_INPORT_PORT: 0x0000000a,
   FILE_DEVICE_KEYBOARD: 0x0000000b,
   FILE_DEVICE_MAILSLOT: 0x0000000c,
   FILE_DEVICE_MIDI_IN: 0x0000000d,
   FILE_DEVICE_MIDI_OUT: 0x0000000e,
   FILE_DEVICE_MOUSE: 0x0000000f,
   FILE_DEVICE_MULTI_UNC_PROVIDER: 0x00000010,
   FILE_DEVICE_NAMED_PIPE: 0x00000011,
   FILE_DEVICE_NETWORK: 0x00000012,
   FILE_DEVICE_NETWORK_BROWSER: 0x00000013,
   FILE_DEVICE_NETWORK_FILE_SYSTEM: 0x00000014,
   FILE_DEVICE_NULL: 0x00000015,
   FILE_DEVICE_PARALLEL_PORT: 0x00000016,
   FILE_DEVICE_PHYSICAL_NETCARD: 0x00000017,
   FILE_DEVICE_PRINTER: 0x00000018,
   FILE_DEVICE_SCANNER: 0x00000019,
   FILE_DEVICE_SERIAL_MOUSE_PORT: 0x0000001a,
   FILE_DEVICE_SERIAL_PORT: 0x0000001b,
   FILE_DEVICE_SCREEN: 0x0000001c,
   FILE_DEVICE_SOUND: 0x0000001d,
   FILE_DEVICE_STREAMS: 0x0000001e,
   FILE_DEVICE_TAPE: 0x0000001f,
   FILE_DEVICE_TAPE_FILE_SYSTEM: 0x00000020,
   FILE_DEVICE_TRANSPORT: 0x00000021,
   FILE_DEVICE_UNKNOWN: 0x00000022,
   FILE_DEVICE_VIDEO: 0x00000023,
   FILE_DEVICE_VIRTUAL_DISK: 0x00000024,
   FILE_DEVICE_WAVE_IN: 0x00000025,
   FILE_DEVICE_WAVE_OUT: 0x00000026,
   FILE_DEVICE_8042_PORT: 0x00000027,
   FILE_DEVICE_NETWORK_REDIRECTOR: 0x00000028,
   FILE_DEVICE_BATTERY: 0x00000029,
   FILE_DEVICE_BUS_EXTENDER: 0x0000002a,
   FILE_DEVICE_MODEM: 0x0000002b,
   FILE_DEVICE_VDM: 0x0000002c,
   FILE_DEVICE_MASS_STORAGE: 0x0000002d,
   FILE_DEVICE_SMB: 0x0000002e,
   FILE_DEVICE_KS: 0x0000002f,
   FILE_DEVICE_CHANGER: 0x00000030,
   FILE_DEVICE_SMARTCARD: 0x00000031,
   FILE_DEVICE_ACPI: 0x00000032,
   FILE_DEVICE_DVD: 0x00000033,
   FILE_DEVICE_FULLSCREEN_VIDEO: 0x00000034,
   FILE_DEVICE_DFS_FILE_SYSTEM: 0x00000035,
   FILE_DEVICE_DFS_VOLUME: 0x00000036,
   FILE_DEVICE_SERENUM: 0x00000037,
   FILE_DEVICE_TERMSRV: 0x00000038,
   FILE_DEVICE_KSEC: 0x00000039,
   FILE_DEVICE_FIPS: 0x0000003A,
};

export const FS_INFORMATION_CLASS = {
   FileFsVolumeInformation: 1,
   FileFsLabelInformation: 2,
   FileFsSizeInformation: 3,
   FileFsDeviceInformation: 4,
   FileFsAttributeInformation: 5,
   FileFsControlInformation: 6,
   FileFsFullSizeInformation: 7,
   FileFsObjectIdInformation: 8,
   FileFsDriverPathInformation: 9,
   FileFsVolumeFlagsInformation: 10,
   FileFsMaximumInformation: 11
};